import { useCallback, useEffect } from 'react';
import produce from 'immer';
import type { MirrorNodeType } from './types';
import useNodeCrud from '../_base/hooks/use-node-crud';
import { useNodesReadOnly } from '../../hooks';

const useConfig = (id: string, payload: MirrorNodeType) => {
  const { nodesReadOnly: readOnly } = useNodesReadOnly();
  const { inputs, setInputs } = useNodeCrud<MirrorNodeType>(id, payload);

  const handleHashChange = useCallback(
    (value: string | number) => {
      const newInputs = produce(inputs, (draft: any) => {
        draft.hash = value;
      });
      setInputs(newInputs);
    },
    [inputs, setInputs],
  );

  const mirrorNodeChange = useCallback(
    (value) => {
      const newInputs = produce(inputs, (draft: any) => {
        draft.mirrorNode = value;
      });
      setInputs(newInputs);
    },
    [inputs, setInputs],
  );

  return {
    readOnly,
    inputs,
    handleHashChange,
    mirrorNodeChange
  };
};

export default useConfig;
